"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.image = exports.wrapper = exports.root = void 0;

var _util = require("../../../util");

const root = ({
  cssProps
}) => {
  const {
    size,
    interactive,
    fullWidth
  } = cssProps;
  const isLarge = size === 'large';
  const defaultWidth = isLarge ? 423 : 276;
  return {
    height: isLarge ? 152 : 112,
    overflow: 'hidden',
    position: 'relative',
    width: fullWidth ? '100%' : defaultWidth,
    transition: 'all 0.2s ease !important',
    ':hover': interactive ? {
      transform: 'scale(1.1)'
    } : undefined
  };
};

exports.root = root;

const wrapper = ({
  cssProps
}) => {
  const {
    size
  } = cssProps;
  const isLarge = size === 'large';
  return {
    maxWidth: isLarge ? 240 : 160
  };
};

exports.wrapper = wrapper;

const image = ({
  cssProps,
  theme
}) => {
  const {
    fullBleed,
    size
  } = cssProps;
  const isLarge = size === 'large';
  const margin = isLarge ? (0, _util.spacing)(theme, 'xlarge') : (0, _util.spacing)(theme, 'medium');
  return {
    bottom: 0,
    height: fullBleed ? '100%' : "calc(100% - ".concat(margin, "px - ").concat(margin, "px)"),
    margin: fullBleed ? 0 : margin,
    position: 'absolute',
    right: 0
  };
};

exports.image = image;
//# sourceMappingURL=PromotionalCard.style.js.map